import React, { useState, useEffect } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { FaTrash, FaPlus, FaWrench, FaSave, FaQuestionCircle, FaChevronUp, FaChevronDown } from "react-icons/fa";
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Footer from "../../composant_reutilisable/footer";
import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";
import Select from 'react-select';

const Parametrage = () => {
  useAuth();
  const utilisateur_id = localStorage.getItem("userId");
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  const navigate = useNavigate();

  const [showInfo, setShowInfo] = useState(false);

  // État unique pour tous les paramètres
  const [parametres, setParametres] = useState({
    emailAdmin: "",
    emailsCopie: [""],
    joursAvantEcheance: {
      niveau1: 30,
      niveau2: 15,
      niveau3: 7
    },
    nombre_elements_par_page: 5,
    duree_affichage_page: 5,

    active_agrement: true

  });

  // Fonction pour récupérer les paramètres depuis le back-end
  const recupererParametres = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/info-parametres-notifications/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setParametres({
          emailAdmin: data.data.email_admin || "Non_defini",
          emailsCopie: data.data.emails_copie?.length > 0
            ? data.data.emails_copie
            : ["email@exemple.com"],
          joursAvantEcheance: {
            niveau1: data.data.jours_avant_echeance?.niveau1 || 30,
            niveau2: data.data.jours_avant_echeance?.niveau2 || 15,
            niveau3: data.data.jours_avant_echeance?.niveau3 || 7
          },
          nombre_elements_par_page: data.data.nombre_elements_par_page || 5,
          duree_affichage_page: data.data.duree_affichage_page || 5,

          active_agrement: data.data.active_agrement ?? true

        });
      } else {
        setParametres(prev => ({
          ...prev,
          emailsCopie: ["exemple@domaine.com"],
          delai_renonciation: 15 // Valeur par défaut
        }));
        showAlert(data.message || "Erreur lors de la récupération des paramètres", 'danger');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
      setParametres(prev => ({
        ...prev,
        emailsCopie: ["exemple@domaine.com"],
        delai_renonciation: 15 // Valeur par défaut
      }));
      showAlert("Erreur de connexion au serveur", 'danger');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (utilisateur_id) {
      document.title = "Transportpro | Liste Paramètres";
      // Charger les paramètres au montage du composant
      recupererParametres();
    }
  }, [utilisateur_id]);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: "", type: "" });
    }, 5000);
  };

  // Gestion des emails en copie
  const ajouterEmailCopie = () => {
    setParametres({
      ...parametres,
      emailsCopie: [...parametres.emailsCopie, ""]
    });
  };

  const modifierEmailCopie = (index, value) => {
    const nouveauxEmails = [...parametres.emailsCopie];
    nouveauxEmails[index] = value;
    setParametres({
      ...parametres,
      emailsCopie: nouveauxEmails
    });
  };

  const supprimerEmailCopie = (index) => {
    if (parametres.emailsCopie.length > 1) {
      const nouveauxEmails = parametres.emailsCopie.filter((_, i) => i !== index);
      setParametres({
        ...parametres,
        emailsCopie: nouveauxEmails
      });
    }
  };

  // Gestion des champs généraux
  const handleChange = (field, value) => {
    setParametres({
      ...parametres,
      [field]: value
    });
  };

  const handleChangeMarge = (value) => {
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      setParametres({
        ...parametres,
        marge_charge_utile: numericValue
      });
    }
  };

  // Gestion des jours avant échéance
  const handleChangeJours = (niveau, value) => {
    setParametres({
      ...parametres,
      joursAvantEcheance: {
        ...parametres.joursAvantEcheance,
        [niveau]: parseInt(value) || 0
      }
    });
  };

  const enregistrerParametres = async () => {
    setIsLoadingButton(true)
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/configurer-notifications/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          parametres: {  // Notez la structure imbriquée
            ...parametres,
            typeCamion: parametres.typeCamion  // Assurez-vous que ce champ est inclus
          },
          user_id: utilisateur_id
        }),
      });
      const data = await response.json();

      if (response.ok) {
        showAlert(data.message, 'success');
      } else {
        showAlert(data.message, 'danger');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    } finally {
      setIsLoadingButton(false);
    }
  };


  const [showGlossary, setShowGlossary] = useState(false);

  const [accesGroupes, setAccesGroupes] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem('groupe_id');

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem('groupe_id');
    const accesGroupeStored = localStorage.getItem('accesGroupe');

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupes(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${utilisateur_id}/${groupe}`);
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces.map((item) =>
              item.acces
                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                : []
            ).flat();

            setAccesGroupes(cleanedAccessArray);
          }

          localStorage.setItem('groupe', data.groupe);
          localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (utilisateur_id) {
      verifGroupe();
    }
  }, [utilisateur_id]);

  if (!accesGroupes.includes("Parametres")) {
    return (
      <Pas_acces />
    );
  }

  return (
    <div id="wrapper">
      <Sidebar utilisateur_id={utilisateur_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <FaWrench size={25} className="mr-2" /> Paramètres
                  {/* <span
                    className="ml-3 toggle-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowInfo(!showInfo)}
                  >
                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                  </span> */}
                </div>

                {/* Bouton d'aide complètement à droite */}
                {/* <button
                  className="btn btn-link p-0 ml-2"
                  title="Manuel d'utilisation"
                  onClick={() => navigate('/Manuel-utilisation-admin', {
                    state: {
                      fromModule: 'administration',
                      fromSection: 'admin-parametres'
                    }
                  })}
                >
                  <FaQuestionCircle size={18} />
                </button> */}
                <button
                  className="btn btn-link p-0 ml-2"
                  title="Aide"
                  onClick={() => setShowGlossary(true)}
                >
                  <FaQuestionCircle size={18} />
                </button>
              </h2>
              <small>Gestion des paramètres.</small>

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/Menu`}> Accueil</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/Admin`}> Administration</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item active">
                    Paramètres
                  </li>
                </ol>
              </small>
            </div>
          </div>

          {alert.message && (
            <div className={`alert alert-${alert.type} mt-3`}>
              {alert.message}
            </div>
          )}

          <div className="container wrapper wrapper-content animated fadeInRight mt-3">
            <div className="row">
              <div className="col-lg-12">
                <div className="ibox">
                  <div className="ibox-content">
                    <div className="d-flex gap-4">
                      {/* Onglets verticaux */}
                      <div className="col-4">
                        <div className="nav flex-column nav-pills">
                          <div
                            className={`nav-link ${activeTab === "general" ? "active" : ""}`}
                            onClick={() => setActiveTab("general")}
                            style={{ cursor: 'pointer' }}
                          >
                            Général
                          </div>
                          <div
                            className={`nav-link ${activeTab === "notification" ? "active" : ""}`}
                            onClick={() => setActiveTab("notification")}
                            style={{ cursor: 'pointer' }}
                          >
                            Notification d'expiration des pièces
                          </div>
                          <div
                            className={`nav-link ${activeTab === "ecran" ? "active" : ""}`}
                            onClick={() => setActiveTab("ecran")}
                            style={{ cursor: 'pointer' }}
                          >
                            Configuration pour affichage des écrans
                          </div>
                          <div
                            className={`nav-link ${activeTab === "marge" ? "active" : ""}`}
                            onClick={() => setActiveTab("marge")}
                            style={{ cursor: 'pointer' }}
                          >
                            Paramétrage pour exploiter les agréments
                          </div>
                        </div>
                      </div>

                      {/* Contenu des onglets */}
                      <div className="flex-grow-1 mt-3 col-8">
                        {/* Onglet Général */}
                        {activeTab === "general" && (
                          <div className="card p-3 wrapper wrapper-content animated fadeInRight mt-3">
                            <div className="d-flex form-group mb-4 justify-content-between">
                              <label className="form-label">Email de l'administrateur :</label>
                              <input
                                type="email"
                                className="form-control w-50"
                                value={parametres.emailAdmin}
                                onChange={(e) => handleChange("emailAdmin", e.target.value)}
                                placeholder="admin@exemple.com"
                              />
                            </div>

                            <div className="form-group">
                              <div className="d-flex justify-content-between mb-2">
                                <label className="form-label">Email(s) en copie :</label>
                                <div className="w-50">
                                  {parametres.emailsCopie.map((email, index) => (
                                    <div key={index} className="d-flex mb-2">
                                      <input
                                        type="email"
                                        className="form-control me-2"
                                        value={email}
                                        onChange={(e) => modifierEmailCopie(index, e.target.value)}
                                        placeholder="email@exemple.com"
                                      />
                                      {parametres.emailsCopie.length > 1 && (
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => supprimerEmailCopie(index)}
                                        >
                                          <FaTrash />
                                        </button>
                                      )}
                                    </div>
                                  ))}
                                  <div className="text-right">
                                    <button
                                      className="btn btn-success btn-sm mt-2"
                                      onClick={ajouterEmailCopie}
                                    >
                                      <FaPlus />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Onglet Notification */}
                        {activeTab === "notification" && (
                          <div className="card mb-4 p-3 wrapper wrapper-content animated fadeInRight mt-3">
                            <div className="d-flex form-group mb-3 align-items-center">
                              <label className="form-label me-3 mr-4">A</label>
                              <input
                                type="number"
                                className="form-control me-3 mr-4"
                                style={{ width: "100px" }}
                                value={parametres.joursAvantEcheance.niveau1}
                                onChange={(e) => handleChangeJours("niveau1", e.target.value)}
                                min="1"
                              />
                              <span className="me-3">jours de la date d'expiration</span>
                            </div>

                            <div className="d-flex form-group mb-3 align-items-center">
                              <label className="form-label me-3 mr-4">A</label>
                              <input
                                type="number"
                                className="form-control me-3 mr-4"
                                style={{ width: "100px" }}
                                value={parametres.joursAvantEcheance.niveau2}
                                onChange={(e) => handleChangeJours("niveau2", e.target.value)}
                                min="1"
                              />
                              <span className="me-3">jours de la date d'expiration</span>
                            </div>

                            <div className="d-flex form-group mb-3 align-items-center">
                              <label className="form-label me-3 mr-4">A</label>
                              <input
                                type="number"
                                className="form-control me-3 mr-4"
                                style={{ width: "100px" }}
                                value={parametres.joursAvantEcheance.niveau3}
                                onChange={(e) => handleChangeJours("niveau3", e.target.value)}
                                min="1"
                              />
                              <span className="me-3">jours de la date d'expiration</span>
                            </div>
                          </div>
                        )}

                        {/* Onglet Ecran */}
                        {activeTab === "ecran" && (
                          <div className="card p-3 wrapper wrapper-content animated fadeInRight mt-3">
                            <div className="d-flex form-group mb-4 justify-content-between">
                              <label className="form-label">Nombre de camions par page :</label>
                              <input
                                type="number"
                                className="form-control w-50"
                                value={parametres.nombre_elements_par_page}
                                onChange={(e) => handleChange("nombre_elements_par_page", e.target.value)}
                                min="1"
                                placeholder="Entrez le nombre de camions à afficher par page"
                              />
                            </div>

                            <div className="form-group">
                              <div className="d-flex form-group mb-4 justify-content-between">
                                <label className="form-label">Durée d'affichage (en secondes) :</label>
                                <input
                                  type="number"
                                  className="form-control w-50"
                                  value={parametres.duree_affichage_page}
                                  onChange={(e) => handleChange("duree_affichage_page", e.target.value)}
                                  min="1"
                                  placeholder="Entrez la durée d'affichage des éléments"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {activeTab === "marge" && (
                          <div className="card p-3 wrapper wrapper-content animated fadeInRight mt-3">
                            <div className="form-group">
                              <div className="d-flex justify-content-between align-items-center mb-4">
                                <label className="form-label"> Activer/Désactiver la sélection des camions agrées aux bailleurs :</label>

                                {/* SWITCH */}
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={parametres.active_agrement}
                                    onChange={() =>
                                      setParametres(prev => ({
                                        ...prev,
                                        active_agrement: !prev.active_agrement
                                      }))
                                    }
                                  />
                                  <label className="form-check-label">
                                    {parametres.active_agrement ? "ON" : "OFF"}
                                  </label>
                                </div>

                              </div>
                            </div>
                          </div>
                        )}


                        {/* Bouton Enregistrer */}
                        <div className="text-right mt-4">
                          <button
                            className="btn btn-success"
                            onClick={enregistrerParametres}
                            disabled={isLoadingButton}
                          >
                            <FaSave />
                            {isLoadingButton ? "Enregistrement..." : "Enregistrer"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer text-center">
            <Footer />
          </div>
        </div>
      </div>
      <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
    </div>
  );
};

export default Parametrage;